import PropTypes from 'prop-types';
const templateFieldObj = {
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf([
        'string',
        'integer',
        'decimal',
        'bool',
        'date',
        'email',
        'image',
        'group',
        'checkbox'
    ]).isRequired,
    isMandatory: PropTypes.bool,
    isMultiple: PropTypes.bool,
    masterFor: PropTypes.string,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    regExp: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]).isRequired,
        labelKey: PropTypes.string,
        slaveRegExp: PropTypes.string,
        instructionsKey: PropTypes.string
    }))
};
templateFieldObj.fields = PropTypes.arrayOf(PropTypes.shape(templateFieldObj)); // optional, only for group type
export default PropTypes.shape(templateFieldObj);
